import { useEffect } from "react";
import { useRoomContext } from "@livekit/components-react";
import { RoomEvent } from "livekit-client";

export const useLivekitRecorder = () => {
  const room = useRoomContext();
  const egressToken = new URLSearchParams(window.location.search).get("token");

  useEffect(() => {
    if (room) {
      // eslint-disable-next-line no-console -- Needed for Egress
      console.log("START_RECORDING");
      room.on(
        RoomEvent.Disconnected,
        // eslint-disable-next-line no-console -- Needed for Egress
        () => console.log("END_RECORDING"),
      );
    }
  }, [room]);

  return {
    recorderToken: egressToken,
  };
};
